import { CHANGE_USERNAME, SET_USERS } from "../actions/constants";

const defaultState = {
  users: [],
  loading: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_USERS:
      return { ...state, users: action.payload };
    // case VERIFY_USER:
    //   return {
    //     ...state,
    //     users: [
    //       ...state.users.slice(0, action.index),
    //       action.payload,
    //       ...state.users.slice(action.index + 1),
    //     ],
    //   };
    case CHANGE_USERNAME:
      return { ...state, userData: action.payload };
    default:
      return state;
  }
};
